import React from 'react';
import { motion } from 'framer-motion';
import type { LucideIcon } from 'lucide-react';

interface ValueCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
}

export default function ValueCard({ icon: Icon, title, description }: ValueCardProps) {
  return (
    <motion.div
      className="relative bg-white p-8 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300"
      whileHover={{ y: -5 }}
    >
      <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
        <div className="bg-gradient-to-r from-green-600 to-green-400 p-4 rounded-full">
          <Icon className="h-8 w-8 text-white" />
        </div>
      </div>
      
      <div className="mt-8 text-center">
        <h3 className="text-2xl font-semibold text-gray-900">{title}</h3>
        <p className="mt-4 text-gray-600">{description}</p>
      </div>
    </motion.div>
  );
}